import React, { Component } from 'react';
import Table from '../../../Components/Table';
import { Card, CardBody } from 'reactstrap';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';


class TablesData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      columns: props.columns,
      data: props.data,
      title: props.title,
      keyvalue: props.keyvalue
    };
  }

  componentDidMount = () => {
    this.setState({
      columns: this.props.columns,
      data: this.props.data,
      title: this.props.title,
      keyvalue: this.props.keyvalue
    });
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      columns: nextProps.columns,
      data: nextProps.data,
      title: nextProps.title,
      keyvalue: nextProps.keyvalue
    });
  }

  getExceptions = () => {
    // let { ShipmentId } = this.state.shipmentDataPlane
    // rest.EXEC({
    //   _function: 'GetExceptionsByShipmentId',
    //   params: ShipmentId
    // }, fetch).then(success => {
    //   if (success.code === 200) {
    //     this.setState({
    //       data: success.data
    //     })
    //   }
    // })
  }

  toggle = evt => {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  }

  callback = (success) => {
    this.setState(prevState => ({
      modal: !prevState.modal
    }), () => {
      this.getExceptions()
    });
  }

  onError = (error) => {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  }

  renderTitle = () => {
    const { title, keyvalue } = this.state;
    if (keyvalue === 'EmissionsC02') {
      return (
        <div className='titleCardResumen d-flex align-items-center'>
          <span className='icon-emissions icons-front-module no-crusor' />
          {title}
        </div>
        // <legend className='titleCardResumen co2Title'>
        //   <img src="https://magiclog.blob.core.windows.net/europartnerspic/Hoja%20real.svg" alt="CO2" height={30} />
        //   {title}
        // </legend>
      )
    }
    return (
      <legend className='titleCardResumen'>{title}</legend>
    )
  }

  render() {
    const { columns, data } = this.state;
    return (
      <>
        <Card
          className="myCard"
          style={{ width: "100%" }}
        >
          <CardBody>
            {/* <div className="row"> */}
            {/* <div className="col-12"> */}
            {this.renderTitle()}
            {/* </div> */}
            {/* <div className="col-12"> */}
            <Table
              columns={columns}
              data={data}
              subTable={this.props.subTable || false}
              options={{
                large: false,
                downloads: {
                  pdf: false,
                  xlsx: false
                }
              }} />
            {/* </div> */}

            {/* <div hidden={keyvalue === 'Excepciones'} className="col-1">
                <Button variant="fab" mini color="primary" aria-label="Add" onClick={this.toggle} >
                  <Add />
                </Button>
              </div> */}
            {/* </div> */}
          </CardBody>
        </Card>
        <Modal isOpen={this.state.modal} toggle={this.toggle} >
          <ModalHeader toggle={this.toggle}>Create New Exception</ModalHeader>
          <ModalBody>
            {/* <AddMoreExceptions callback={this.callback} onError={this.onError} shipmentDataPlane={this.state.shipmentDataPlane} /> */}
          </ModalBody>
        </Modal>
      </>
    );
  }
}

export default TablesData;
